import { render, staticRenderFns } from "./mini-cart-item.vue?vue&type=template&id=03a03ba4&"
import script from "./mini-cart-item.vue?vue&type=script&lang=js&"
export * from "./mini-cart-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/sites/www/new.crt.ru/html/current_version/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03a03ba4')) {
      api.createRecord('03a03ba4', component.options)
    } else {
      api.reload('03a03ba4', component.options)
    }
    module.hot.accept("./mini-cart-item.vue?vue&type=template&id=03a03ba4&", function () {
      api.rerender('03a03ba4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/components/mini-cart-item/mini-cart-item.vue"
export default component.exports